import path from 'path-browserify';

import { getBaseUrl } from '@api/base-url';

const base = (): string => path.join(getBaseUrl({ version: 1 }), 'users/current/');

const urls = Object.freeze({
  currentUser: (): string => path.join(
    base(),
    '',
  ),
  currentUserDelete: (): string => path.join(
    base(),
    'delete/',
  ),
  currentUserEmail: (): string => path.join(
    base(),
    'email/',
  ),
  currentUserImage: (): string => path.join(
    base(),
    'image/',
  ),
  currentUserLanguages: ({
    userLanguageId = null,
  }: {
    userLanguageId?: number | null;
  } = {}): string => path.join(
    base(),
    'languages/',
    userLanguageId === null ? '' : `${userLanguageId}/`,
  ),
  currentUserLinks: ({
    userLinkId = null,
  }: {
    userLinkId?: number | null;
  } = {}): string => path.join(
    base(),
    'links/',
    userLinkId === null ? '' : `${userLinkId}/`,
  ),
  currentUserPassword: (): string => path.join(
    base(),
    'password/',
  ),
  currentUserTenants: (): string => path.join(
    base(),
    'tenants/',
  ),
  currentUserTenantInvitationCodes: (): string => path.join(
    base(),
    'invitation-codes/',
  ),
  currentUserTenantInvitationCodeAccept: (): string => path.join(
    base(),
    'invitation-codes/accept/',
  ),
  currentUserTenantInvitationCodeDecline: (): string => path.join(
    base(),
    'invitation-codes/decline/',
  ),
});

export default urls;
